import React, { useEffect } from "react";
import SearchBar from "./searchBar";
import { ContactList, ContactListClassic } from "../contacts/contact";
import { searchContact } from "../../api";

function SearchContact({ dataList, LinkFactory, search, setSearch }) {
  const [filterDisplay, setFilterDisplay] = React.useState([]);

  useEffect(() => {
    setSearch(search);
    let oldList = dataList;

    if (search !== "") {
      const search_ = parseAccent(search).toUpperCase();

      searchContact(search).then((data) => {
        const contacts = data.data;
        if (contacts && contacts.length > 0) {
          setFilterDisplay(contacts);
        }
      });
    } else {
      setFilterDisplay(dataList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleChange = (event) => {
    setSearch(event);
  };

  function parseAccent(e) {
    if (e !== "" && e !== null) {
      return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    return "";
  }

  return (
    <>
      <div className="c-container_search-bar">
        <SearchBar
          value={search}
          handleChange={(e) => handleChange(e.target.value)}
        />
      </div>
      <div className="c-container_infos main-data">
        {search.length == 0 && (
          <ContactList contacts={dataList} LinkFactory={LinkFactory} />
        )}
        {search.length >= 1 && (
          <ContactListClassic
            contacts={search.length < 1 ? dataList : filterDisplay}
            LinkFactory={LinkFactory}
          />
        )}
      </div>
    </>
  );
}

export default SearchContact;
